function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as o } from "./index.es33.js";
import { clsx as y } from "./index.es105.js";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import "./index.es97.js";
import "./index.es98.js";
import "./index.es99.js";
import "./index.es100.js";
import "./index.es101.js";
import "./index.es102.js";
import "./index.es103.js";
import "./index.es104.js";
import { palette as h } from "./index.es36.js";
import { Icon as m } from "./index.es7.js";
import "./index.es133.js";
import "react";
import "react-dom";
import { isEmpty as j } from "./index.es159.js";
import "./index.es134.js";
import { useSelectContext as b } from "./index.es132.js";
import { createLabelAndIcon as g } from "./index.es573.js";
import r from "./index.es574.js";

var K = function K(_ref) {
  var _y;

  var p = _ref.placeholder,
      s = _ref.isClearable,
      a = _ref.toggleIsOpen,
      e = _ref.isDisabled,
      l = _ref.isTruncated,
      c = _ref.isLoading;

  var _b = b(),
      i = _b.value,
      u = _b.onOptionClick,
      _g = g({
    placeholder: p,
    isLoading: c,
    isDisabled: e
  }),
      f = _g.placeholderLabel,
      x = _g.SelectIcon,
      n = !!(Array.isArray(i) ? i.length : !j(i === null || i === void 0 ? void 0 : i.value)),
      d = function d(t) {
    t.preventDefault(), t.stopPropagation(), u === null || u === void 0 ? void 0 : u({
      value: ""
    });
  };

  return o.jsxs(o.Fragment, {
    children: [o.jsx("div", {
      className: y(r.inner, (_y = {}, _defineProperty(_y, r.innerPale, !n), _defineProperty(_y, r.innerTruncated, n && l), _y)),
      children: f
    }), !e && s && n && o.jsx("button", {
      type: "button",
      className: r.clearButton,
      onMouseDown: function onMouseDown(t) {
        t.stopPropagation(), t.preventDefault();
      },
      onClick: d,
      disabled: e,
      children: o.jsx(m, {
        icon: m.icons.system.s.utilities.cross,
        size: 16,
        color: h.gray6,
        className: "icon--clear"
      })
    }), o.jsx("button", {
      type: "button",
      className: r.arrowButton,
      onClick: a,
      disabled: e,
      children: x
    })]
  });
};

export { K as SelectControl };